<div class="d-flex justify-content-end align-items-center p-2 bg-primary text-white">
    <button *ngIf="pagina > 1 && pagina < 3" class="btn btn-outline-light mr-3" (click)="voltar()"><i
            class="fas fa-angle-left"></i>&nbsp;{{ data.BOTAO_ANTERIOR }}</button>
    <button *ngIf="pagina < 3" [disabled]="!isValid" class="btn btn-outline-light" (click)="avancar()">{{
        data.BOTAO_PROXIMO }}&nbsp;<i class="fas fa-angle-right"></i></button>
    <button *ngIf="pagina==3" class="btn btn-outline-light" [routerLink]="[ data.URL_HOME ] | localize">{{
        data.BOTAO_FINALIZAR }}</button>
</div>